var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import './details.component.less';
import { extend, isArray } from 'lodash';
import { Stratus } from '@stratusjs/runtime/stratus';
import 'angular-material';
import 'angular-sanitize';
import { isJSON, safeUniqueId } from '@stratusjs/core/misc';
import { cookie } from '@stratusjs/core/environment';
import '@stratusjs/angularjs-extras';
const min = !cookie('env') ? '.min' : '';
const packageName = 'idx';
const moduleName = 'member';
const componentName = 'details';
const localDir = `${Stratus.BaseUrl}${Stratus.DeploymentPath}@stratusjs/${packageName}/src/${moduleName}/`;
const localDistStyle = `${Stratus.BaseUrl}${Stratus.DeploymentPath}@stratusjs/${packageName}/dist/${packageName}.bundle.min.css`;
Stratus.Components.IdxMemberDetails = {
    bindings: {
        elementId: '@',
        tokenUrl: '@',
        urlLoad: '@',
        pageTitle: '@',
        service: '@',
        memberKey: '@',
        memberStateLicense: '@',
        images: '@',
        openhouses: '@',
        googleApiKey: '@',
        options: '@',
        defaultListOptions: '@'
    },
    controller($attrs, $q, $scope, Idx) {
        $scope.uid = safeUniqueId(packageName, moduleName, componentName);
        $scope.elementId = $attrs.elementId || $scope.uid;
        Stratus.Instances[$scope.elementId] = $scope;
        if ($attrs.tokenUrl) {
            Idx.setTokenURL($attrs.tokenUrl);
        }
        Stratus.Internals.CssLoader(localDistStyle).then();
        this.$onInit = () => {
            $scope.options = $attrs.options && isJSON($attrs.options) ? JSON.parse($attrs.options) : {};
            $scope.options.urlLoad = $attrs.urlLoad && isJSON($attrs.urlLoad) ? JSON.parse($attrs.urlLoad) : true;
            $scope.options.pageTitle = $attrs.pageTitle && isJSON($attrs.pageTitle) ? JSON.parse($attrs.pageTitle) : false;
            $scope.options.service = $attrs.service ? $attrs.service : null;
            $scope.options.MemberKey = $attrs.memberKey ? $attrs.memberKey : null;
            $scope.options.MemberStateLicense = $attrs.memberStateLicense ? $attrs.memberStateLicense : null;
            $scope.options.images = $attrs.images && isJSON($attrs.images) ? JSON.parse($attrs.images) : {
                fields: [
                    'Order',
                    'MediaURL',
                    'LongDescription'
                ]
            };
            $scope.googleApiKey = $attrs.googleApiKey || null;
            $scope.defaultListOptions = $attrs.defaultListOptions && isJSON($attrs.defaultListOptions) ?
                JSON.parse($attrs.defaultListOptions) : {};
            $scope.memberMerged = {};
            $scope.memberCombined = {};
            Idx.registerDetailsInstance($scope.elementId, moduleName, $scope);
            console.log('options', $scope.options, $attrs);
            $scope.fetchMember().then();
            Idx.emit('init', $scope);
        };
        $scope.$watch('collection.models', (models) => __awaiter(this, void 0, void 0, function* () {
            $scope.devLog('Loaded Member Data:', models);
            yield $scope.individualMember();
            if ($scope.options.pageTitle &&
                (Object.prototype.hasOwnProperty.call($scope.memberMerged, 'MemberFullName') ||
                    Object.prototype.hasOwnProperty.call($scope.memberMerged, 'MemberFirstName'))) {
                Idx.setPageTitle($scope.memberMerged.MemberFullName || `${$scope.memberMerged.MemberFirstName} ${$scope.memberMerged.MemberLastName}`);
            }
        }));
        $scope.fetchMember = () => __awaiter(this, void 0, void 0, function* () {
            const memberQuery = {
                service: [$scope.options.service],
                where: {}
            };
            if ($scope.options.MemberKey) {
                memberQuery.where.MemberKey = $scope.options.MemberKey;
            }
            else if ($scope.options.MemberStateLicense) {
                memberQuery.where.MemberStateLicense = $scope.options.MemberStateLicense;
            }
            if ($scope.options.images) {
                memberQuery.images = $scope.options.images;
            }
            if (memberQuery.service &&
                (memberQuery.where.MemberKey || memberQuery.where.MemberStateLicense)) {
                yield Idx.fetchMembers($scope.elementId, 'collection', memberQuery, true, 'MemberDetailsList');
            }
            else {
                console.error('No Service Id or Member Key/License is fetch from');
            }
        });
        $scope.individualMember = () => __awaiter(this, void 0, void 0, function* () {
            return $q((resolve) => {
                if ($scope.collection && $scope.collection.completed && $scope.collection.models.length > 0) {
                    $scope.memberMerged = {};
                    const tempCollection = [].concat($scope.collection.models).reverse();
                    tempCollection.forEach((agent) => {
                        extend($scope.memberMerged, agent);
                    });
                    $scope.memberCombined = {};
                    $scope.collection.models.map((agent) => {
                        Object.keys(agent).forEach((key) => {
                            if (!isArray(agent[key]) ||
                                (isArray(agent[key]) && agent[key].length > 0)) {
                                $scope.memberCombined[key] = $scope.memberCombined[key] || [];
                                if (!$scope.memberCombined[key].includes(agent[key])) {
                                    $scope.memberCombined[key].push(agent[key]);
                                }
                            }
                        });
                    });
                }
                resolve();
            });
        });
        $scope.getMLSName = () => Idx.getMLSVariables($scope.model.data._ServiceId)[0].name;
        $scope.on = (emitterName, callback) => Idx.on($scope.elementId, emitterName, callback);
        $scope.remove = () => {
        };
        $scope.devLog = (item1, item2) => {
            if (cookie('env')) {
                console.log(item1, item2);
            }
        };
    },
    templateUrl: ($attrs) => `${localDir}${$attrs.template || componentName}.component${min}.html`
};

//# sourceMappingURL=details.component.js.map
